// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fu3P","type":"styles_type__3xa4j","choices":"styles_choices__1OLSZ"};